<template>
  <router-link :to="url" custom disabled ref="dd" v-slot="{}">
    <li class="nav-item nav-dropdown router-link-exact-active">
      <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-fw fa-xs" :class="icon"></i> {{name}}</div>
      <ul class="nav-dropdown-items">
        <slot></slot>
      </ul>
    </li>
  </router-link>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  },
  mounted () {
    if (!this.expanded) {
      this.$refs.dd.$el.classList.remove('open')
    }
  }
}
</script>
